<div class="py-4 container-fluid users-management-page">
  <h4 class="mb-4 users-management-title">การตั้งค่า - ผู้ใช้งาน</h4>

  <div class="users-management-card">
    <div class="users-management-card-body">
      <div class="users-management-toolbar" [formGroup]="form">
        <div class="users-management-filters">
          <div class="users-management-filter users-management-filter-keyword">
            <app-filter-search-input
              label="ตำแหน่งทางวิชาการ, ชื่อ - นามสกุล, อีเมล"
              formControlName="keywords"
              inputClass="users-management-search-input"
              classes="mb-0"
              ariaLabel="ค้นหาผู้ใช้งาน"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          <div class="users-management-filter">
            <app-select
              label="ตำแหน่ง"
              formControlName="position_id"
              [options]="dropdownOptions().positions"
              bindLabel="name"
              bindValue="id"
              inputClass="users-management-select"
              classes="mb-0"
              (inputChange)="onFilterSelectChange('position_id', $event)"
            ></app-select>
          </div>

          <div class="users-management-filter">
            <app-select
              label="สาขาวิชา"
              formControlName="department_id"
              [options]="dropdownOptions().departments"
              bindLabel="name"
              bindValue="id"
              inputClass="users-management-select"
              classes="mb-0"
              (inputChange)="onFilterSelectChange('department_id', $event)"
            ></app-select>
          </div>

          <div class="users-management-filter">
            <app-select
              label="บทบาทการใช้งาน"
              formControlName="role_id"
              [options]="dropdownOptions().roles"
              bindLabel="label"
              bindValue="value"
              inputClass="users-management-select"
              classes="mb-0"
              (inputChange)="onFilterSelectChange('role_id', $event)"
            ></app-select>
          </div>
        </div>

        <div class="users-management-buttons">
          <button
            type="button"
            class="btn btn-outline users-management-outline-button"
            [disabled]="isDownloadingTemplate"
            (click)="onDownloadTemplate()"
          >
            <img src="assets/media/icons/svg/file-down.svg" class="users-management-toolbar-icon" alt="" aria-hidden="true" />
            <span>ดาวน์โหลดแบบฟอร์ม</span>
          </button>

          <button
            type="button"
            class="btn btn-outline users-management-outline-button"
            data-bs-toggle="modal"
            data-bs-target="#importDataModal"
            (click)="onImport()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="users-management-toolbar-icon" alt="" aria-hidden="true" />
            <span>นำเข้าข้อมูล</span>
          </button>

          <button
            type="button"
            class="btn btn-outline users-management-outline-button"
            [disabled]="isImportingBankAccounts"
            (click)="onImportBankAccounts()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="users-management-toolbar-icon" alt="" aria-hidden="true" />
            <span>นำเข้าเลขที่บัญชี</span>
          </button>

          <button
            type="button"
            class="btn users-management-add-button"
            (click)="onAddUser()"
          >
            <img src="assets/media/icons/svg/add-item.svg" class="users-management-toolbar-icon" alt="" aria-hidden="true" />
            <span>เพิ่มรายการใหม่</span>
          </button>
        </div>
      </div>

      <ng-template #rowIndexTemplate let-row="row" let-rowIndex="rowIndex">
        {{ row.sequence ?? users().offset + rowIndex + 1 }}
      </ng-template>

      <ng-template #tableCellAction let-row="row">
        <div class="users-management-actions">
          <button
            type="button"
            class="btn users-management-action-button"
            (click)="onEditUser(row)"
            aria-label="แก้ไขผู้ใช้งาน"
          >
            <img
              src="assets/media/icons/svg/pencxil.svg"
              class="users-management-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>

          <button
            type="button"
            class="btn users-management-action-button"
            (click)="onDeleteUser(row)"
            aria-label="ลบผู้ใช้งาน"
          >
            <img
              src="assets/media/icons/svg/trush.svg"
              class="users-management-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="users()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="users().page"
        [limit]="users().limit"
        [total]="users().total"
        [totalPage]="users().total_page"
        [offset]="users().offset"
        [dataLength]="users().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="Users pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<app-form-import-new
  #importForm
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>
<app-confirm-dialog
  #importSuccessDialog
  modalId="importUsersSuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  message="นำเข้าข้อมูลผู้ใช้งานเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importSuccessDialog.close()"
></app-confirm-dialog>
<app-form-import-new
  #bankImportForm
  modalId="importBankAccountsModal"
  title="นำเข้าเลขที่บัญชี"
  [isSaving]="isImportingBankAccounts"
  (saved)="onImportBankAccountsFile($event)"
></app-form-import-new>
<app-confirm-dialog
  #importBankAccountsSuccessDialog
  modalId="importBankAccountsSuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  [message]="bankImportSuccessMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importBankAccountsSuccessDialog.close()"
></app-confirm-dialog>
<app-form-add-user
  (saved)="onUserSaved($event)"
  (saveFailed)="onUserSaveFailed($event)"
></app-form-add-user>
<app-confirm-dialog
  #deleteUserConfirmDialog
  modalId="deleteUserConfirm"
  title="ยืนยันการลบรายการ"
  message="คุณต้องการลบรายการนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isDeleting"
  (confirmed)="onConfirmDeleteUser()"
  (cancelled)="onCancelDeleteUser()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteUserSuccessDialog
  modalId="deleteUserSuccess"
  icon="success"
  title="ลบรายการสำเร็จ"
  message="ลบข้อมูลผู้ใช้งานเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteUserSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteUserErrorDialog
  modalId="deleteUserError"
  icon="error"
  title="ไม่สามารถลบรายการได้"
  [message]="deleteUserErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteUserErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createUserSuccessDialog
  modalId="createUserSuccess"
  icon="success"
  title="เพิ่มรายการสำเร็จ"
  message="เพิ่มข้อมูลผู้ใช้งานเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createUserSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createUserErrorDialog
  modalId="createUserError"
  icon="error"
  title="ไม่สามารถเพิ่มรายการได้"
  [message]="createUserErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createUserErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editUserSuccessDialog
  modalId="editUserSuccess"
  icon="success"
  title="แก้ไขรายการสำเร็จ"
  message="แก้ไขข้อมูลผู้ใช้งานเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editUserSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editUserErrorDialog
  modalId="editUserError"
  icon="error"
  title="ไม่สามารถแก้ไขรายการได้"
  [message]="editUserErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editUserErrorDialog.close()"
></app-confirm-dialog>
